import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-modal_open_catnav_bottom_cta-click';
/**
 * Event fired when user clicks the bottom sign up banner in the logged out category page
 * @deprecated by Alier Hu on February 16th, 2024
 */
export function trackSignupModalOpenCatnavBottomCtaClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
